import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { reduce } from 'lodash';
import { Breadcrumb as BreadcrumbSitebase, Anchor } from '@sitebase/ui-kit';

import { TOPICS } from '../../../../server/utils/constants';

import './breadcrumb.scss';

const Breadcrumb = ({ breadcrumbElements, mobile = false }) => {
    const breadcrumbsElementCss = classNames('breadcrumbs', {
        'breadcrumbs--mobile': mobile,
    });

    const goBack = () => {
        window.WH.sportsbook.from.page
            ? window.history.back()
            : window.WH.messageBus.publish('internalRoute', { url: '/betting/' + window.WH.sportsbook.lang });
    };

    const trackAnalytic = (clickedBreadcrumbText) => {
        const topic = mobile ? TOPICS.MOBILE : TOPICS.DESKTOP;
        let breadcrumbOrder;
        const breadcrumbText = reduce(
            document.querySelectorAll('#breadcrumbsV2-app a'),
            (text, { textContent }, ind) => {
                text += text ? '/' + textContent : textContent;
                if (clickedBreadcrumbText === textContent) {
                    breadcrumbOrder = ind + 1;
                }
                return text;
            },
            ''
        );
        window.WH.messageBus.publish(
            topic,
            `SB|Breadcrumb|${breadcrumbText}|${clickedBreadcrumbText}|${breadcrumbOrder}`
        );
    };

    const navigateTo = (e, url) => {
        e.preventDefault();
        trackAnalytic(e.currentTarget.textContent);
        window.WH.messageBus.publish('internalRoute', { url });
    };

    return (
        <div styleName={breadcrumbsElementCss}>
            <BreadcrumbSitebase onGoBackRequest={goBack}>
                {breadcrumbElements.map(({ path, name }, index) => (
                    <Anchor
                        className="non-route"
                        onClick={(e) => navigateTo(e, path)}
                        outfit="secondary"
                        href={path}
                        key={`breadcrumb-${name}-${index}`}
                    >
                        {name}
                    </Anchor>
                ))}
            </BreadcrumbSitebase>
        </div>
    );
};

export const breadcrumbElementsPropTypes = PropTypes.arrayOf(
    PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
    })
);

Breadcrumb.propTypes = {
    breadcrumbElements: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
        })
    ).isRequired,
    pageTitle: PropTypes.string,
    mobile: PropTypes.bool,
};

export default Breadcrumb;
